import 'react';
import '../../../../../../_virtual/index.mjs';
import '../atoms/Typography.module.css.mjs';

const OneTapErrors = {
    // These come from the Google GSI Client
    OriginNotAllowedForClient: 'origin_not_allowed_for_client',
    InvalidOAuthClient: 'invalid_client',
    // These come from the API directly - err.error_type
    NoConfiguredOAuthClient: 'oauth_config_not_found',
    NoConfiguredLoginRedirectUrls: 'no_login_redirect_urls_set',
    NoConfiguredSignupRedirectUrls: 'no_signup_redirect_urls_set',
    DefaultProviderNotAllowed: 'default_provider_not_allowed'
};

export { OneTapErrors };
//# sourceMappingURL=OneTapError.mjs.map
